module.exports = __webpack_public_path__ + "static/media/layer4.2683e612.png";